export const SVGNS = 'http://www.w3.org/2000/svg';
